import * as globals from '@wandb/weave/common/css/globals.styles';
import {Icon, IconCheckmark} from '@wandb/weave/components/Icon';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled, {css} from 'styled-components';

export const GrayIcon = styled(Icon)`
  color: ${globals.MOON_600};
  padding-left: 4px;
`;

export const CheckmarkIcon = styled(IconCheckmark)`
  color: ${globals.TEAL_550};
  padding-left: 4px;
`;

export const DropdownTextWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: flex-end;
`;

export const DropdownLabel = styled.span`
  color: ${globals.MOON_600};
`;

export const DropdownBold = styled.span`
  display: flex;
  align-items: center;
  padding-left: 4px;
`;

export const DropdownTriggerWrapper = styled.div`
  color: ${globals.MOON_800};
  :hover {
    color: ${globals.TEAL_550};
  }

  font-size: 14px;
  font-weight: 600;
  line-height: 18px;

  display: flex;
  align-items: center;

  margin-left: 32px;
`;

export const RowWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  height: 72px;
  padding: 24px 32px;

  color: ${globals.MOON_800};
  background-color: ${globals.MOON_100};

  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  text-align: left;
  width: 100%;

  border-bottom-left-radius: 8px !important;
  border-bottom-right-radius: 8px !important;
`;

export const CopyLink = styled.span<{$isCopied: boolean}>`
  display: flex;
  align-items: center;
  gap: 8px;

  min-width: 100px;

  ${({$isCopied}) =>
    $isCopied
      ? css`
          cursor: default;
        `
      : css`
          cursor: pointer;
        `}
`;

export const LabelText = styled.span`
  font-size: 14px;
  font-weight: 400;
  text-align: right;
  color: ${globals.MOON_600};
`;
